/* Layout */
import Layout from "@/views/layout/Layout";

export default [
  {
    path: "/goodsEvaluateManage",
    component: Layout,
    alwaysShow: false,
    meta: {
      title: "商品评价",
      icon: "component"
    },
    children: [
      {
        path: "/goodsEvaluateManage/evaluateManage",
        component: () =>
          import(
            "@/myviews/shoppMall/productManage/evaluateManage/commodityEvaluate.vue"
          ),
        alwaysShow: false,
        name: "CommodityEvaluate",
        meta: {
          title: "商品评价",
          icon: "component",
          roles: ["add", "modify", "viewpage"],
          have: []
        }
      },
      {
        path: "/productManage/evaluateDetail",
        component: () =>
          import(
            "@/myviews/shoppMall/productManage/evaluateManage/evaluateDetail.vue"
          ),
        name: "EvaluateDetail",
        hidden: true,
        meta: {
          alwaysShow: false,
          title: "评价详情",
          icon: "component",
          roles: ["add", "modify", "viewpage"],
          have: []
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/shoppMall/goodsEvaluate.js